import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { FeedbackProps } from "./Types";
import { useTranslations } from "./../../contexts/translationContext";

const ControlFeedback: React.FC<FeedbackProps> = ({ isValid, validationResults }) => {
    const [validationErrors, setErrors] = useState<string[]>([]);
    const { translate, replaceArguments } = useTranslations();

    useEffect(() => {
        if (validationResults) {
            let errors: string[] = [];
            for (let i = 0; i < validationResults.length; i++) {
                let result = validationResults[i];
                translate(result.format, 'Validation messages')
                    .then(translated => {
                        errors.push(replaceArguments(translated, result.args))
                        setErrors(() => [...errors]);
                    });
            }
        }
    }, [validationResults, translate]);

    return <>
        {validationErrors.map(x => <Form.Control.Feedback type={isValid ? 'valid' : 'invalid'} key={x}>{x}</Form.Control.Feedback>)}
    </>
}
export default ControlFeedback;
